export enum UserRoles {
    adminUser = 'AdminUser',
    user = 'User',
    workCompUser = 'WorkCompUser',
    referralUser = 'ReferralUser',
}